import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';
import CarePlanTasksTable from './carePlanTasksTable';
import { fetchRpmCarePlanTaskList, setSelectedRpmPatient } from '../../../../../../../Redux/actions/rpmActions';

function Index() {
    const [currentPage, setCurrentPage] = useState(1);
    const { isLoading, careTasksList, selectedRpmPatient } = useSelector((state) => state.rpm);
    const dispatch = useDispatch();

    useEffect(() => {
        const payload = {
            patientId: selectedRpmPatient.patientId,
            status: 1
        }
        dispatch(fetchRpmCarePlanTaskList(payload));
    }, []);

    useEffect(() => {
        if (!selectedRpmPatient) {
            const rpmPatientJson = localStorage.getItem('rpmPatient');
            const rpmPatientObject = rpmPatientJson ? JSON.parse(rpmPatientJson) : null;
            if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
        }
    }, []);


    return (
        <div>
            {
                isLoading && careTasksList?.length === 0 ? (
                    <div className="flex items-center justify-center mt-[10%]">
                        <Flex align="center" gap="middle">
                            <Spin size="large" tip="Loading" />
                        </Flex>
                    </div>
                ) :
                    // careTasksList?.length === 0 ?
                    //     (<div className="flex flex-col items-center justify-center">
                    //         <img src={nodatafound} alt="nodatafound" className="h-20 w-20" />
                    //         <p className="font-medium">No data found!!</p>
                    //     </div>
                    //     )
                    //     :
                    (
                        <div>
                            <CarePlanTasksTable
                                data={careTasksList}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                totalCount={careTasksList?.length}
                            />
                        </div>
                    )
            }
        </div>
    )
}

export default Index;